<template>
  <v-dialog v-model="internalVisible" max-width="600px" persistent>
    <v-card>
      <v-card-title class="headline">新增天災停班</v-card-title>
      <v-card-text>
        <v-alert type="warning" outlined class="mb-4">
          <strong>注意：</strong>此操作將為全公司所有在職員工新增天災停班記錄
        </v-alert>

        <v-form ref="form" v-model="formValid">
          <v-row>
            <v-col cols="12" sm="6">
              <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formData.startDate"
                    label="開始日期"
                    prepend-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                    :rules="[(v) => !!v || '請選擇開始日期']"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="formData.startDate"
                  @input="startDateMenu = false"
                  @change="onStartDateChange"
                  locale="zh-TW"
                  color="blue"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6">
              <v-menu
                v-model="startTimeMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formData.startClock"
                    label="開始時間"
                    prepend-icon="mdi-clock-outline"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                    :rules="[(v) => !!v || '請選擇開始時間']"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-model="formData.startClock"
                  format="24hr"
                  full-width
                  color="blue"
                  @input="startTimeMenu = false"
                ></v-time-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6">
              <v-menu
                v-model="endDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formData.endDate"
                    label="結束日期"
                    prepend-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                    :rules="[
                      (v) => !!v || '請選擇結束日期',
                      () => validateEndDateTime(),
                    ]"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="formData.endDate"
                  @input="endDateMenu = false"
                  locale="zh-TW"
                  color="blue"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6">
              <v-menu
                v-model="endTimeMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formData.endClock"
                    label="結束時間"
                    prepend-icon="mdi-clock-outline"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                    :rules="[
                      (v) => !!v || '請選擇結束時間',
                      () => validateEndDateTime(),
                    ]"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-model="formData.endClock"
                  format="24hr"
                  full-width
                  color="blue"
                  @input="endTimeMenu = false"
                ></v-time-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-text-field
            v-if="false"
            v-model.number="formData.leaveMinutes"
            label="假期時數（分鐘）"
            type="number"
            outlined
            dense
            :rules="[(v) => v > 0 || '請輸入有效的分鐘數']"
            hint="例如：480分鐘 = 8小時"
            persistent-hint
          ></v-text-field>

          <v-radio-group
            v-model="formData.paymentOption"
            :rules="[(v) => !!v || '請選擇一個選項']"
            class="mt-4"
          >
            <template v-slot:label>
              <div class="font-weight-medium">出勤與給薪選項</div>
            </template>
            <v-radio
              label="不出勤給薪(該日停班，薪資照常給付)"
              value="不出勤給薪"
              color="primary"
            ></v-radio>
            <v-radio
              label="不出勤不給薪(該日停班，薪資不給付)"
              value="不出勤不給薪"
              color="primary"
            ></v-radio>
            <v-radio
              label="出勤加倍給薪(有出勤者加倍給付工資。未出勤者工資不計。)"
              value="出勤加倍給薪"
              color="primary"
            ></v-radio>
            <v-radio
              label="出勤不加倍給薪(有出勤者不用加倍給付工資（正常計薪）。但未出勤者工資不計)"
              value="出勤不加倍給薪"
              color="primary"
            ></v-radio>
            <v-radio
              label="出勤加倍給薪再給補休"
              value="出勤加倍給薪再給補休"
              color="primary"
            ></v-radio>
          </v-radio-group>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="
            font-weight-bold
            text-capitalize
            btn-ls btn-secondary
            bg-gradient-light
            py-3
            px-6
          "
          @click="closeDialog"
          :disabled="submitting"
        >
          取消
        </v-btn>
        <v-btn
          class="
            font-weight-bold
            text-capitalize
            btn-primary
            bg-gradient-primary
            py-3
            px-6
          "
          @click="showConfirmation"
          :disabled="!formValid || submitting"
        >
          確認
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="showConfirmDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline">確認新增天災停班</v-card-title>
        <v-card-text>
          <div class="mb-3">
            <strong>此操作將為全公司所有在職員工新增天災停班記錄</strong>
          </div>
          <div>
            開始時間：{{ formatDateTime(formData.startDate, formData.startClock) }}
          </div>
          <div>
            結束時間：{{ formatDateTime(formData.endDate, formData.endClock) }}
          </div>
          <div>
            假期時數：{{ formData.leaveMinutes }} 分鐘（{{
              formatMinutesToHours(formData.leaveMinutes)
            }}
            小時）
          </div>
          <div>出勤與給薪選項：{{ formData.paymentOption }}</div>
          <div class="mt-3 red--text">確定要繼續嗎？</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
            @click="showConfirmDialog = false"
            :disabled="submitting"
          >
            取消
          </v-btn>
          <v-btn
            class="
              font-weight-bold
              text-capitalize
              btn-primary
              bg-gradient-primary
              py-3
              px-6
            "
            @click="submitForm"
            :loading="submitting"
            :disabled="submitting"
          >
            確定送出
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
export default {
  name: "CreateTyphoonLeaveDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      formValid: false,
      submitting: false,
      startDateMenu: false,
      startTimeMenu: false,
      endDateMenu: false,
      endTimeMenu: false,
      showConfirmDialog: false,
      formData: {
        startDate: null,
        startClock: "09:00",
        endDate: null,
        endClock: "18:00",
        leaveMinutes: 480,
        paymentOption: null,
      },
    };
  },
  computed: {
    internalVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
  methods: {
    onStartDateChange(value) {
      if (value) {
        this.formData.endDate = value;
      }
    },
    formatDateTime(date, time) {
      if (!date || !time) return "";
      return `${date} ${time}`;
    },
    validateEndDateTime() {
      const {
        startDate,
        startClock,
        endDate,
        endClock,
      } = this.formData;
      if (!startDate || !startClock || !endDate || !endClock) {
        return true;
      }
      const start = new Date(`${startDate}T${startClock}:00`);
      const end = new Date(`${endDate}T${endClock}:00`);
      if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
        return "日期時間格式錯誤";
      }
      return end >= start || "結束時間不可早於開始時間";
    },
    formatMinutesToHours(minutes) {
      if (!minutes) return "0";
      return (minutes / 60).toFixed(1);
    },
    showConfirmation() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.showConfirmDialog = true;
    },
    closeDialog() {
      this.internalVisible = false;
      this.showConfirmDialog = false;
      this.resetForm();
    },
    resetForm() {
      this.formData = {
        startDate: null,
        startClock: "09:00",
        endDate: null,
        endClock: "18:00",
        leaveMinutes: 480,
        paymentOption: null,
      };
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    async submitForm() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.submitting = true;

      try {
        const startDateTimeLocal = `${this.formData.startDate}T${this.formData.startClock}:00`;
        const endDateTimeLocal = `${this.formData.endDate}T${this.formData.endClock}:00`;
        const startTimeIsoUtc = new Date(startDateTimeLocal).toISOString();
        const endTimeIsoUtc = new Date(endDateTimeLocal).toISOString();

        const payload = {
          company_id: this.companyId,
          start_time: startTimeIsoUtc,
          end_time: endTimeIsoUtc,
          leave_minutes: this.formData.leaveMinutes,
          reason: this.formData.paymentOption,
        };

        const response = await this.$axios.post(
          "/api/leave-records/typhoon",
          payload,
        );

        this.$emit("success", response.data);
        this.closeDialog();
      } catch (error) {
        console.error("Error creating typhoon leave:", error);
        this.$emit("error", {
          title: "新增失敗",
          message:
            error.response?.data?.message ||
            "新增天災停班時發生錯誤，請稍後再試。",
        });
      } finally {
        this.submitting = false;
        this.showConfirmDialog = false;
      }
    },
  },
};
</script>
